import { createTheme, ThemeOptions } from '@mui/material/styles';
import { themeColor } from './color';
import { typography } from './typography';
import { components } from './components';
import { radius } from '../radius';

/**
 * Spacing tokens 1–12 per the design system. Use directly when you need exact
 * Figma values, e.g. `padding: spacingTokens[3]`. For sx/MUI's `theme.spacing`,
 * pass an integer factor to look up the token; fractional factors fall back to
 * `factor * 4px` so existing consumers using e.g. `sx={{ p: 0.5 }}` still work.
 */
export const spacingTokens = [
  0, 4, 12, 16, 20, 24, 32, 40, 46, 64, 72, 80, 96,
] as const;

const spacing = (factor: number): string => {
  if (
    Number.isInteger(factor) &&
    factor >= 0 &&
    factor < spacingTokens.length
  ) {
    return `${spacingTokens[factor]}px`;
  }
  return `${factor * 4}px`;
};

/**
 * Pixel-keyed spacing lookup for sx props: `sp[16]` → `'16px'`.
 * Covers all values used in the old SC theme plus common extras.
 */
export const sp: Record<number, string> = Object.fromEntries(
  [0, 4, 8, 12, 16, 20, 24, 32, 40, 46, 48, 64, 72, 80, 96].map((n) => [
    n,
    `${n}px`,
  ]),
);

export const gridGap: Record<string, string> = {
  xs: '4px 8px',
  sm: '8px 12px',
  md: '16px 12px',
  default: '24px 32px',
};

export const themeOptions: ThemeOptions = {
  palette: themeColor.palette,
  typography,
  components,
  spacing,
  shape: {
    borderRadius: radius.sm,
  },
};
export const theme = createTheme(themeOptions);
